const cargoType = {
  breakbulk: 'Breakbulk',
  bulk: 'Bulk',
};

export default cargoType;
